export const newsNavUK = state => state.news.newsNav.newsNavUK;
export const newsNavRU = state => state.news.newsNav.newsNavRU;
export const newsNavErrorUK = state => state.news.newsNav.newsNavErrorRU;
export const newsNavErrorRU = state => state.news.newsNav.newsNavErrorRU;
export const newsNavLoading = state => state.news.newsNav.loading;
